import { useEffect } from 'react'
import {
  sendEnrollmentHeartbeatBeacon,
  submitEnrollmentHeartbeatRequest
} from '@/api/enrollment-api'
import { isSelfEnrollmentTrackedStep, SELF_ENROLLMENT_STEPS } from '../utils/steps'

type UseEnrollmentHeartbeatEffectArgs = {
  currentStep: number
  enrollmentSessionToken: string | null
  totalSteps: number
}

export function useEnrollmentHeartbeatEffect({
  currentStep,
  enrollmentSessionToken,
  totalSteps
}: UseEnrollmentHeartbeatEffectArgs) {
  useEffect(() => {
    if (
      !enrollmentSessionToken ||
      currentStep === SELF_ENROLLMENT_STEPS.ELIGIBILITY ||
      currentStep === SELF_ENROLLMENT_STEPS.LICENSE_DETAILS ||
      currentStep === SELF_ENROLLMENT_STEPS.CONTACT_DETAILS ||
      currentStep === SELF_ENROLLMENT_STEPS.ENGLISH_PROFICIENCY ||
      currentStep === SELF_ENROLLMENT_STEPS.LOCATION_SELECTION ||
      currentStep === SELF_ENROLLMENT_STEPS.REMOVED_PROGRAM_SELECTION ||
      currentStep === SELF_ENROLLMENT_STEPS.ADDITIONAL_INFO ||
      currentStep === SELF_ENROLLMENT_STEPS.TRAINING_DATE ||
      currentStep === SELF_ENROLLMENT_STEPS.REMOVED_TUITION_SUMMARY ||
      currentStep === SELF_ENROLLMENT_STEPS.UPLOAD_DOCUMENTS ||
      currentStep === SELF_ENROLLMENT_STEPS.SIGN_DOCUMENTS ||
      currentStep === SELF_ENROLLMENT_STEPS.SIGNED_COMPLETE ||
      currentStep === SELF_ENROLLMENT_STEPS.ENROLLMENT_COMPLETE ||
      !isSelfEnrollmentTrackedStep(currentStep) ||
      currentStep > totalSteps
    ) {
      return
    }

    const data = { step: currentStep }
    const dropoffData = { step: currentStep, dropoff: true }

    const sendHeartbeat = () => {
      void submitEnrollmentHeartbeatRequest({
        sessionToken: enrollmentSessionToken,
        data
      }).catch(() => {})
    }

    const flushHeartbeat = () => {
      sendEnrollmentHeartbeatBeacon(enrollmentSessionToken, data)
    }

    const flushDropoff = () => {
      sendEnrollmentHeartbeatBeacon(enrollmentSessionToken, dropoffData)
    }

    const handleVisibilityChange = () => {
      if (document.visibilityState === 'hidden') {
        flushHeartbeat()
        return
      }

      sendHeartbeat()
    }

    sendHeartbeat()

    const intervalId = window.setInterval(sendHeartbeat, 30000)
    window.addEventListener('pagehide', flushDropoff)
    document.addEventListener('visibilitychange', handleVisibilityChange)

    return () => {
      window.clearInterval(intervalId)
      window.removeEventListener('pagehide', flushDropoff)
      document.removeEventListener('visibilitychange', handleVisibilityChange)
    }
  }, [currentStep, enrollmentSessionToken, totalSteps])
}
